var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + (_vm.tag > 6 ? 6 : _vm.tag)),{tag:"component",staticClass:"title tw-600",class:_vm.classList[_vm.tag]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }